<template>
  <vs-popup full-screen class="dhl-tracking-popup" id="popup" :title="`${courier_shipment_code} - DHL TRACKING`"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-table :data="tracking_data.events" noDataText="No tracking events yet">

        <template slot="thead">
          <vs-th>DATE</vs-th>
          <vs-th>TIME</vs-th>
          <vs-th>TYPE CODE</vs-th>
          <vs-th>DESCRIPTION</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].date">
              {{ data[indextr].date }}
            </vs-td>

            <vs-td :data="data[indextr].time">
              {{ data[indextr].time }}
            </vs-td>

            <vs-td :data="data[indextr].typeCode">
              {{ data[indextr].typeCode }}
            </vs-td>

            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>

          </vs-tr>
        </template>

      </vs-table>

    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const DHLRepository = RepositoryFactory.get('dhl')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    tracking_id: '',
    courier_shipment_code: '',
    tracking_data: {
      events: []
    }
  }
}

export default {
  name: 'DhlShipmentTrackingPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(tracking_id, courier_shipment_code) {
      try {
        await Object.assign(this.$data, initialState())
        this.courier_shipment_code = courier_shipment_code
        this.tracking_id = tracking_id
        await this.fetchDhlTracking()
        this.open = true
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async fetchDhlTracking() {
      this.$vs.loading()
      try {
        const { data } = (await DHLRepository.fetchShipmentTrackingData(this.tracking_id)).data
        this.tracking_data = data.shipments[0]
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close()
      }
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.shipment-delivery-note-pop-up>>>.vs-popup {
  /*min-height: 78% !important;*/
  /*min-width: 60% !important;*/
}
</style>
